import { UNI_ADDRESSES } from '@uniswap/sdk-core'
import { UniverseChainId } from 'uniswap/src/features/chains/types'
import { CurrencyInfo } from 'uniswap/src/features/dataApi/types'

export function getPreferredTokenLogoUrl(
  currencyInfo: CurrencyInfo,
  tokenListLogoUrl?: string | null,
): string | null | undefined {
  const { currency, logoUrl } = currencyInfo
  const isMainnetUni =
    currency.isToken &&
    currency.chainId === UniverseChainId.Mainnet &&
    currency.address.toLowerCase() === UNI_ADDRESSES[UniverseChainId.Mainnet]?.toLowerCase()

  return isMainnetUni ? tokenListLogoUrl || logoUrl : logoUrl || tokenListLogoUrl
}
